import docxtemplater from "docxtemplater";
import JSZip from "jszip";
import JSZipUtils from "jszip-utils";
import { saveAs } from "file-saver";
/*
 4. 导出docx
 5. @param { String } tempDocxPath 模板文件路径
 6. @param { Object } data 文件中传入的数据
 7. @param { String } fileName 导出文件名称
*/
export const exportDocx = (tempDocxPath, data, fileName) => {
  // 读取并获得模板文件的二进制内容
  JSZipUtils.getBinaryContent("tmp.docx", (error, content) => {
    if (error) {
      throw error;
    }
    const ctt = content;
    let zip = new JSZip(ctt);
    let doc = new docxtemplater().loadZip(zip);
    doc.setData(data);
    try {
      // render the document (replace all occurences of {first_name} by John, {last_name} by Doe, ...)
      doc.render();
    } catch (error) {
      let e = {
        message: error.message,
        name: error.name,
        stack: error.stack,
        properties: error.properties
      };
      console.log({
        error: e
      });
      // The error thrown here contains additional information when logged with JSON.stringify (it contains a property object).
      throw error;
    }
    let out = doc.getZip().generate({
      type: "blob",
      mimeType:
        "application/vnd.openxmlformats-officedocument.wordprocessingml.document"
    }); //Output the document using Data-URI
    saveAs(out, fileName);
  });
};

/**
 * 
 * @param {json} data 文本数据
 * @param {string} fileName 文本名称
 * 
 */
export const exportTXT = (data, fileName) => {
  let str = new Blob([data], { type: "text/plain;charset=utf-8" });
  // 注意这里要手动写上文件的后缀名
  saveAs(str, `${fileName}.txt`);
};
export const exportFile =function(url,name){
  saveAs(url, name);
} 
